import axios from './axios-instance'

const BASEURL = '/rates?'

export default {
  // eslint-disable-next-line no-undef
  async get(type = currentRateType) {
    return axios.get(`${BASEURL}type=${type}`)
  },
}
